import { Badge, Box, Link, SimpleGrid, SimpleGridProps, Stack } from '@chakra-ui/react'
import { useAuthContext } from 'context/AuthProvider'
import * as React from 'react'
import { useHistory } from 'react-router'
import { FooterHeading } from '../FooterHeading'
import { useTranslation } from 'react-i18next'

export const LinkGrid: React.FC<SimpleGridProps> = ({ ...props }) => {
  const history = useHistory()
  const { isAuthenticated } = useAuthContext()
  const { t } = useTranslation()
  return (
    <SimpleGrid fontSize="sm" columns={2} {...props}>
      <Box minW="130px">
        <FooterHeading mb="4">Product</FooterHeading>
        <Stack>
          <Link
            onClick={() => history.push(isAuthenticated ? '/auth/how-it-works' : '/how-it-works')}
          >
            {t('footer.how_it_works')}
          </Link>
          <Link>Pricing</Link>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/use-cases' : '/use-cases')}>
            {t('footer.use_cases')}
          </Link>
        </Stack>
      </Box>
      <Box minW="130px">
        <FooterHeading mb="4">Legal</FooterHeading>
        <Stack>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/privacy' : '/privacy')}>
            {t('footer.privacy')}
          </Link>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/terms' : '/terms')}>
            {t('footer.terms')}
          </Link>
          <Link>{t('footer.licience')}</Link>
        </Stack>
      </Box>
      <Box minW="130px">
        <FooterHeading mb="4">Company</FooterHeading>
        <Stack>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/about-us' : '/about-us')}>
            {t('top_nav_about_us_link')}
          </Link>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/about-us' : '/about-us')}>
            {t('footer.why_nsoko')}
          </Link>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/history' : '/history')}>
            {t('footer.our_story')}
          </Link>

          <Link onClick={() => history.push(isAuthenticated ? '/auth/career' : '/career')}>
            {t('footer.careers')}
            <Badge mx={2} fontSize="x-small" colorScheme="blue">
              {t('footer.hiring')}
            </Badge>
          </Link>
          <Link onClick={() => history.push(isAuthenticated ? '/auth/team' : '/team')}>
            {t('footer.team')}
          </Link>
        </Stack>
      </Box>
    </SimpleGrid>
  )
}
